import { TableOfContentsSkeleton } from '../TableOfContents';
import { PageSkeleton } from './PageSkeleton';

/**
 * Skeleton of the entire space.
 */
export function SpaceContentSkeleton() {
    return (
        <div className="flex flex-1">
            <TableOfContentsSkeleton />
            <PageSkeleton />
        </div>
    );
}
